import { InputElement } from "./InputElement";
/**
 * Input Radio Element
 */
export class InputRadioElement extends InputElement {
    /**
     * Constructor
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    constructor(htmlElement, bindData, context) {
        super(htmlElement, bindData, context);
    }
    /**
     * Sets element value
     * @param value element value
     */
    setValue(value) {
        this.getHtmlElement().checked = (this.getHtmlElement().value === value);
    }
    /**
     * Gets element value
     */
    getValue() {
        return this.getHtmlElement().value;
    }
    /**
     * Sets readonly
     * @param readonly readonly or not
     */
    setReadonly(readonly) {
        if (readonly) {
            this.getHtmlElement().style.pointerEvents = 'none';
        }
        else {
            this.getHtmlElement().style.pointerEvents = '';
        }
    }
}
//# sourceMappingURL=InputRadioElement.js.map